<template>
  <div v-if="isVisible">
    <div class="dimd" />
    <div id="popAlertSim" class="pop_wrap type02" style="display: block">
      <div class="alert">
        <h3>[안내] 위성통신서비스 이용약관 변경 안내</h3>
        <div class="popup-inner">
          <p>안녕하십니까. SK텔링크입니다. <br /></p>
          <p>
            당사의 위성통신서비스를 이용하고 계신 고객님께 감사의 말씀을
            드립니다. <br />
            글로벌 항행 안전 규제 확산에 따라 안정되고 다양한 위성통신서비스
            제공을 위해 인말샛 C(Inmarsat C)에 대한 요금제를 보완 및 개편하여
            <span class="color-red">06월 01일</span>부터 시행할 예정입니다.
          </p>
          <p>
            주요 개정사항은 아래과 같으며, 세부 사항은 첨부에 게시된 이용약관
            전문을 참조 부탁 드립니다.
          </p>
          <p class="font-weight-bold">[이용약관 주요 개정 사항]</p>
          <ul>
            <li>
              - 인말샛 C 기본료, 부가서비스, Data Reporting 등 요금제 개편
            </li>
            <li>- 약관 [별표] 요금표 중 인말샛 C 항목</li>
            <li>
              - 자세한 사항은 첨부의 변경 예정 이용약관 전문 참조
              <a
                class="color-red font-weight-bold"
                href="/content/notice/SK텔링크 위성통신서비스 이용약관 전문_250430.pdf"
                download
                >[링크]</a
              >
            </li>
          </ul>
          <p class="font-weight-bold">[시행일자] 2025년 06월 01일</p>
          <p>
            앞으로도 SK텔링크는 고객님의 기대에 부응하기 위하여 최상의
            위성통신서비스를 제공하겠습니다.
          </p>
        </div>
        <div class="not-week">
          <div class="check_box">
            <input
              id="agree"
              v-model="agreeClose"
              type="checkbox"
              @change="change"
            />
            <label for="agree"><span>오늘 하루 보지 않음</span></label>
          </div>
        </div>
        <a class="pop-close" @click="$emit('update:is-visible', false)"
          ><img src="/content/images/btn_pop_close.png" alt="닫기"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utilities";
export default {
  name: "PopupAnnounce",
  props: {
    // serviceName: {
    //   type: String,
    //   required: true
    // },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      agreeClose: false,
    };
  },

  methods: {
    change() {
      if (this.agreeClose) {
        util.setCookie("inmarsat", "Y", 1);
        this.$emit("update:is-visible", false);
      }
    },
  },
};
</script>

<style></style>
